import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NivelacionesComponent } from '../nivelaciones/nivelaciones.component';
import { CitacionMateriaCursoComponent } from '../nivelaciones/citacion-materia-curso/citacion-materia-curso.component';
import { NivelacionesAlumnoComponent } from '../nivelaciones/nivelaciones-alumnos/nivelaciones-alumno.component';
import { NivelacionesDirectorCursoComponent } from '../nivelaciones/nivelaciones-director-curso/nivelaciones-director-curso.component';
import { NivelacionesReporteComponent } from '../nivelaciones/nivelaciones-reporte/nivelaciones-reporte.component';
import { NivelacionesDirectivoComponent } from '../nivelaciones/nivelaciones-directivo/nivelaciones-directivo.component';
import { EstudioResumenResolver } from '../estudio/resumen/estudio-resumen-resolver.service';
import { NivelacionesAlumnoResolver } from '../estudio/_resolvers/nivelaciones-alumno-resolver.service';
import { NivelacionesResolver } from '../estudio/_resolvers/nivelaciones-resolver.service';
import { NivelacionesCursoResolver } from '../estudio/_resolvers/nivelaciones-curso-resolver.service';
import { NivelacionesHomeComponent } from './nivelaciones-home/nivelaciones-home.component';
import { NivelacionesReporteCursoComponent } from './nivelaciones-reporte-curso/nivelaciones-reporte-curso.component';
import { NivelacionesEspecialesComponent } from './nivelaciones-especiales/nivelaciones-especiales.component';

const routes: Routes = [{
  //   path: 'inicio',
  //   component: NivelacionesHomeComponent
  // },{
    path: 'mis-nivelaciones/mes/:idMes',
    component: NivelacionesAlumnoComponent,
    resolve: {
      nivelaciones: NivelacionesAlumnoResolver,
    }
  },{
    path: 'materia/:id/mes/:idMes',
    component: CitacionMateriaCursoComponent,
    resolve: {
      nivelaciones: NivelacionesResolver,
    }
  },{
    path: 'especiales/fecha/:fecha',
    component: NivelacionesEspecialesComponent
  },{
    path: 'especiales',
    component: NivelacionesEspecialesComponent
  },{
    path: 'reportes',
    resolve: {
      periodos: EstudioResumenResolver
    },
    children: [
      {
        path: 'rutas/fecha/:fecha',
        component: NivelacionesReporteComponent
      },{
        path: 'rutas',
        component: NivelacionesReporteComponent
      },{
        path: 'director-curso/:id/periodo/:idPeriodo',
        component: NivelacionesDirectorCursoComponent,
        resolve: {
          nivelaciones: NivelacionesCursoResolver,
        }
      },{
        path: 'director-curso/:id',
        component: NivelacionesDirectorCursoComponent,
        resolve: {
          nivelaciones: NivelacionesCursoResolver,
        }
      },{
        path: 'directivo/periodo/:idPeriodo',
        component: NivelacionesDirectivoComponent,
        // resolve: {
        //     nivelaciones: NivelacionesResolver,
        // }
      },{
        path: 'directivo',
        component: NivelacionesDirectivoComponent,
        // resolve: {
        //     nivelaciones: NivelacionesResolver,
        // }
      },{
        path: 'cursos/periodo/:idPeriodo',
        component: NivelacionesReporteCursoComponent
      },{
        path: 'cursos',
        component: NivelacionesReporteCursoComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NivelacionesRoutingModule { }
